import { toRefs } from '@vueuse/shared';

import type {
  UseNavigationReturn,
  UseNavigationState,
  FetchNavigation
} from '~/composables/useNavigation/types';
import { useSdk } from '~/sdk';

/**
 * @description Composable managing customer order data
 * @returns {@link UseNavigationReturn}
 * @example
 * const { data, loading, fetchNavigation } = useNavigation();
 */
export const useNavigation: UseNavigationReturn = (id) => {
  const state = useState<UseNavigationState>(`useNavigation-${id}`, () => ({
    data: null,
    loading: false,
  }));

  /** Function for fetching customer order data
   * @example
   * fetchNavigation();
   */
  const fetchNavigation: FetchNavigation = async (handle) => {
    state.value.loading = true;
    const { data, error } = await useAsyncData(() => {
      return useSdk().statamic.getNavigation(handle);
    });
    useHandleError(error.value);
    state.value.data = data;
    state.value.loading = false;

    return data;
  };

  return {
    fetchNavigation,
    ...toRefs(state.value),
  };
};
